import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import { IFormSection } from "../../types/common";
import { API_DEBIT_HOLDINGS_TYPES } from "../../utils/apis";
import {
  createColumn,
  createViewAction,
  formatDateTime,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_DEBIT_HOLDINGS_TYPES } from "../../utils/urls";

export const useDebitHoldingTypes = () => {
  const tableColumns = () => [
    createColumn("created_by", true, "Created By"),
    createColumn("type_code", true, "Type Code"),
    createColumn("debit_holding_type", true, "Debit Holding Type"),
    createColumn("description", true, "Description"),
    createColumn("is_active", true, "Is Active"),
    createColumn("created_at", true, "Created At"),
    createColumn("actions", false, "Actions"),
  ];

  const tableData = (data: any) => {
    return data?.map((item: any) => {
      return {
        ...item,
        created_by:
          item?.created_by?.first_name + " " + item?.created_by?.last_name,
        is_active: <BooleanTags status={item?.is_active} />,
        created_at: formatDateTime(item?.created_at),

        actions: (
          <FormActions
            actions={[createViewAction(URL_DEBIT_HOLDINGS_TYPES, item?.id)]}
          />
        ),
      };
    });
  };

  const viewData = (item: any) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: {
              message: "No data available",
            },
          },
        ],
      };
    }
    return {
      sections: [
        {
          title: "Debit Holding Type Details",
          fields: {
            debit_holding_type: item?.debit_holding_type,
            type_code: item?.type_code,
            description: item?.description,
            is_active: <BooleanTags status={item?.is_active} />,
            created_at: formatDateTime(item?.created_at),
            updated_at: formatDateTime(item?.updated_at),
          },
        },
      ],
    };
  };

  const formRoute = getForm(URL_DEBIT_HOLDINGS_TYPES);

  return {
    tableColumns,
    tableData,
    viewData,
    formRoute,
  };
};

export const useDebitHoldingTypesForm = () => {
  const sections: IFormSection[] = [
    {
      title: "Debit Holding Type",
      fields: [
        {
          field_name: "debit_holding_type",
          label: "Debit Holding Type",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "type_code",
          label: "Type Code",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "description",
          label: "Description",
          type: "textarea",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_DEBIT_HOLDINGS_TYPES);

  return {
    sections,
    redirect,
  };
};

export const submitDebitHoldingTypes = (payload: any, id: string) => {
  if (id) {
    return {
      id,
      api: API_DEBIT_HOLDINGS_TYPES,
      params: {
        ...payload,
      },
    };
  }
  return {
    api: API_DEBIT_HOLDINGS_TYPES,
    params: {
      ...payload,
    },
  };
};
